import { render } from "./CardTitulo.vue?vue&type=template&id=28632302&scoped=true"
import script from "./CardTitulo.vue?vue&type=script&lang=js"
export * from "./CardTitulo.vue?vue&type=script&lang=js"

import "./CardTitulo.vue?vue&type=style&index=0&id=28632302&lang=css&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28632302"]])

export default __exports__